import { Grid } from '@mui/material';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../../contexts/cancellation.context';
import { setCookie } from '../../../../utils/generaFunctions';

const OfferConfirmed = () => {
    const {userInfo, setLoading} = useContext(CancelContext);
    useEffect(()=>{
        setLoading(false);
        setCookie("cancellation-"+userInfo.email,"yes", 1/12);
    })
    return (
        <Grid container className='confirmed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>Special price confirmed</h1>
                </Grid>
                <Grid item className='body-book' >
                    We’re thrilled to keep you in the Tum To Mom community.<br/>Your boxes will be just <span className='body-demi'>$31.99 + shipping & tax</span>, until the end of your subscription.
                </Grid>
            </Grid>
        </Grid>
    )
}

export default OfferConfirmed;